<template>
  <div>
    <hwhead></hwhead>
    <keep-alive>
      <router-view v-if="$route.meta.notCache!==true" />
    </keep-alive>
    <router-view v-if="$route.meta.notCache===true" />
    <el-row>
      <el-col :span="24" class="footdiv">
        @中国国旅（宁波）国际旅行社有限公司
      </el-col>
    </el-row>
  </div>
</template>
<script>

import hwhead from "_c/base/headmain"
export default {
  name: "home",
  components: {
    hwhead
  },
  data() {
    return {
    }
  }
};
</script>
<style lang="less">
.footdiv {
  border-top: 1px solid #dcdfe6;
  height: 100px;
  text-align: center;
  padding: 20px;
  font-size: 14px;
  color: #909399;
  margin-top: 100px;
}
</style>
